export default {
  env: 'development',
  apiBaseURL: 'http://docker.test:5050/api',
};
